var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    zoomAndPan: "magnify",
    viewBox: "0 0 30 30.000001",
    height: 40,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "7981e5c1e1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.488281 2.140625 L 29.515625 2.140625 L 29.515625 6.953125 L 0.488281 6.953125 Z M 0.488281 2.140625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "018100eb6e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.488281 11.648438 L 29.515625 11.648438 L 29.515625 16.574219 L 0.488281 16.574219 Z M 0.488281 11.648438 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b75147c3b2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.488281 21.269531 L 29.515625 21.269531 L 29.515625 26.09375 L 0.488281 26.09375 Z M 0.488281 21.269531 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7981e5c1e1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M 27.113281 6.933594 L 2.886719 6.933594 C 1.558594 6.933594 0.488281 5.859375 0.488281 4.535156 C 0.488281 3.214844 1.558594 2.140625 2.886719 2.140625 L 27.113281 2.140625 C 28.441406 2.140625 29.515625 3.214844 29.515625 4.535156 C 29.515625 5.859375 28.441406 6.933594 27.113281 6.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#018100eb6e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M 27.113281 16.515625 L 2.886719 16.515625 C 1.558594 16.515625 0.488281 15.441406 0.488281 14.121094 C 0.488281 12.796875 1.558594 11.722656 2.886719 11.722656 L 27.113281 11.722656 C 28.441406 11.722656 29.515625 12.796875 29.515625 14.121094 C 29.515625 15.441406 28.441406 16.515625 27.113281 16.515625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b75147c3b2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#DCDCDC",
    d: "M 27.113281 26.097656 L 2.886719 26.097656 C 1.558594 26.097656 0.488281 25.023438 0.488281 23.703125 C 0.488281 22.378906 1.558594 21.304688 2.886719 21.304688 L 27.113281 21.304688 C 28.441406 21.304688 29.515625 22.378906 29.515625 23.703125 C 29.515625 25.023438 28.441406 26.097656 27.113281 26.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.c4c8fdd74157644a99bf16c8d38da757.svg";
export { ForwardRef as ReactComponent };